<template>
  <div class="upc-card">
    <!-- Header -->
    <div class="upc-header">
      <div class="upc-header-icon">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
      </div>
      <div class="upc-header-info">
        <div class="upc-header-label">Plano Atual</div>
        <div class="upc-plan-name">{{ userData.currentPlan || 'Sem plano' }}</div>
      </div>
      <span class="upc-plan-badge" :class="userData.currentPlan === 'PRO Booster' ? 'upc-badge-pro' : 'upc-badge-vsl'">
        {{ userData.currentPlan === 'PRO Booster' ? 'PRO' : 'STARTER' }}
      </span>
    </div>

    <!-- Plan Date -->
    <div class="upc-since" v-if="userData.dataPlan">
      <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/><line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/><line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/><line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/></svg>
      Ativo desde {{ userData.dataPlan }}
    </div>

    <!-- Plays Usage -->
    <div class="upc-usage" v-if="userData.currentPlan">
      <div class="upc-usage-header">
        <span class="upc-usage-label">Plays consumidos</span>
        <span class="upc-usage-value">
          <strong>{{ (userData.qtde_play || 0).toLocaleString('pt-BR') }}</strong>
          <span class="upc-usage-limit"> / {{ planLimit.toLocaleString('pt-BR') }}</span>
        </span>
      </div>
      <div class="upc-progress-track">
        <div class="upc-progress-fill" :style="{ width: progressPct + '%' }" :class="progressPct > 80 ? 'upc-fill-danger' : progressPct > 60 ? 'upc-fill-warn' : 'upc-fill-ok'"></div>
      </div>
      <div class="upc-usage-footer">
        <span class="upc-remaining" :class="playsLeft <= 0 ? 'upc-remaining-danger' : ''">
          {{ playsLeft > 0 ? playsLeft.toLocaleString('pt-BR') + ' plays restantes' : 'Limite atingido' }}
        </span>
        <span class="upc-pct">{{ progressPct }}%</span>
      </div>
    </div>

    <!-- Features -->
    <div class="upc-features">
      <div class="upc-feature">
        <div class="upc-feature-check">✓</div>
        <span>Todos os recursos inclusos</span>
      </div>
      <div class="upc-feature">
        <div class="upc-feature-check">✓</div>
        <span>Analytics avançado</span>
      </div>
      <div class="upc-feature">
        <div class="upc-feature-icon">$</div>
        <span>R$ 0,02 por play extra</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserViewUserPlanCard',
  props: {
    userData: { type: Object, required: true },
  },
  computed: {
    planLimit() {
      return this.userData.currentPlan === 'PRO Booster' ? 40000 : 15000
    },
    playsLeft() {
      return this.planLimit - (this.userData.qtde_play || 0)
    },
    progressPct() {
      const pct = Math.round(((this.userData.qtde_play || 0) / this.planLimit) * 100)
      return Math.min(pct, 100)
    },
  },
}
</script>

<style scoped>
.upc-card {
  background: var(--dk-bg-card, #fff); border-radius: 16px;
  border: 1.5px solid var(--dk-border-light, #f0f2f5);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  overflow: hidden;
}

/* ─── Header ─── */
.upc-header {
  display: flex; align-items: center; gap: 12px;
  padding: 20px 20px 16px;
  border-bottom: 1.5px solid var(--dk-border-light, #f5f6fa);
}
.upc-header-icon {
  width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; display: flex; align-items: center; justify-content: center;
}
.upc-header-label { font-size: 11px; color: var(--dk-text-faint, #aab0bc); font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }
.upc-plan-name { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #0D3349); margin-top: 1px; }
.upc-plan-badge {
  margin-left: auto; flex-shrink: 0;
  padding: 4px 11px; border-radius: 20px; font-size: 11px; font-weight: 700;
  letter-spacing: 0.05em;
}
.upc-badge-pro { background: linear-gradient(135deg, #E86A10, #F5B935); color: #fff; }
.upc-badge-vsl { background: rgba(232,106,16,0.1); color: #E86A10; border: 1px solid rgba(232,106,16,0.2); }

/* ─── Since ─── */
.upc-since {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 20px; font-size: 12px; color: var(--dk-text-faint, #aab0bc);
  border-bottom: 1.5px solid var(--dk-border-light, #f5f6fa);
}

/* ─── Usage ─── */
.upc-usage { padding: 18px 20px; border-bottom: 1.5px solid var(--dk-border-light, #f5f6fa); }
.upc-usage-header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 10px;
}
.upc-usage-label { font-size: 12px; color: var(--dk-text-muted, #8a94a6); font-weight: 600; }
.upc-usage-value { font-size: 13px; color: var(--dk-text-primary, #344563); font-weight: 700; }
.upc-usage-limit { font-weight: 400; color: var(--dk-text-faint, #aab0bc); }
.upc-progress-track {
  height: 7px; background: var(--dk-bg-inset, #f0f2f5); border-radius: 10px; overflow: hidden;
}
.upc-progress-fill {
  height: 100%; border-radius: 10px; transition: width 0.6s ease;
}
.upc-fill-ok { background: linear-gradient(90deg, #28c76f, #48da89); }
.upc-fill-warn { background: linear-gradient(90deg, #F5B935, #ffcd43); }
.upc-fill-danger { background: linear-gradient(90deg, #E86A10, #ea5455); }
.upc-usage-footer {
  display: flex; justify-content: space-between; align-items: center;
  margin-top: 8px;
}
.upc-remaining { font-size: 11.5px; color: var(--dk-text-muted, #8a94a6); font-weight: 500; }
.upc-remaining-danger { color: #ea5455; font-weight: 600; }
.upc-pct { font-size: 11.5px; color: var(--dk-text-muted, #8a94a6); font-weight: 600; }

/* ─── Features ─── */
.upc-features { padding: 16px 20px; display: flex; flex-direction: column; gap: 10px; }
.upc-feature {
  display: flex; align-items: center; gap: 10px;
  font-size: 13px; color: var(--dk-text-secondary, #5a6a7a);
}
.upc-feature-check {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  background: rgba(40,199,111,0.1); color: #28c76f;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700;
}
.upc-feature-icon {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  background: rgba(245,185,53,0.12); color: #E86A10;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700;
}
</style>
